import { Show, type JSX } from 'solid-js'
import type { BandScope } from 'mormaii-web-presentation/status-bands'
import Css from './status-bands.module.scss'
import { WarningIcon } from './warning-icon'

/** Uma faixa, numa linha so: o ponto, o nivel e os dois limites. */
export function Band(props: { scope: BandScope }): JSX.Element {
    return (
        <div class={Css.band}>
            <span aria-hidden="true" class={Css.dot} style={{ 'background-color': props.scope.color }} />
            <span class={Css.level}>{props.scope.label}</span>

            <Limit
                name={`${props.scope.field}.min`}
                label={`${props.scope.label}: mínimo`}
                value={props.scope.min}
                warning={!!props.scope.warning}
                onChange={(value) => props.scope.onMinChanged(value)}
            />

            <span aria-hidden="true" class={Css.dash}>
                –
            </span>

            <Limit
                name={`${props.scope.field}.max`}
                label={`${props.scope.label}: máximo`}
                value={props.scope.max}
                warning={!!props.scope.warning}
                onChange={(value) => props.scope.onMaxChanged(value)}
            />

            <span
                class={Css.diverges}
                classList={{ [Css.marked]: props.scope.diverges && !props.scope.warning }}
                title={props.scope.inherited ? `Diverge. ${props.scope.inherited}` : undefined}
                aria-label={props.scope.inherited ? `Diverge. ${props.scope.inherited}` : undefined}
            />

            <Show when={props.scope.warning}>
                {(aviso) => (
                    <span class={Css.problem} title={aviso()} aria-label={aviso()}>
                        <WarningIcon />
                    </span>
                )}
            </Show>
        </div>
    )
}

/**
 * Um dos dois limites.
 *
 * Campo PREENCHIDO e sem borda, e nao a caixa branca com contorno dos formularios:
 * sao 56 deles na mesma tela, dentro de sete cartoes que ja tem borda. O
 * preenchimento marca onde se digita sem desenhar mais uma linha.
 */
function Limit(props: {
    name: string
    label: string
    value: string
    warning?: boolean
    onChange: (value: string) => void
}): JSX.Element {
    return (
        <input
            name={props.name}
            aria-label={props.label}
            value={props.value}
            inputmode="decimal"
            onInput={(event) => props.onChange(event.currentTarget.value)}
            class={Css.limit}
            classList={{ [Css.flagged]: props.warning }}
        />
    )
}
